import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import ResultElementParameterSelect from "../../../ResultElementParameterSelect";
import { RecipeScalingApiEndpoints } from "api/api-endpoints";
import { TableElementFormField } from "pages/RS-Workspace/components/Results/components/ElementDialog";
import { restrictionsSelector } from "store/knowledge-base-item/knowledge-base-item.selectors";
import { GetRestrictionsMethod, RequestTemplate } from "store/knowledge-base-item/knowledge-base-item.types";
import { getFieldRestrictions, getRequestName } from "store/knowledge-base-item/knowledge-base-item.utils";
import { ResultElementParameterType, TableElementColumnViewType, } from "store/rs-workspace/rs-workspace.types";
const ColumnDialog = ({ column, columns, onClose, onSubmit, classes }) => {
    const allRestrictions = useSelector(restrictionsSelector({
        rsEndpoint: RecipeScalingApiEndpoints.workspaces,
        method: GetRestrictionsMethod.PUT,
        template: RequestTemplate.TABLE_ELEMENT_PUT,
    }));
    const restrictions = useMemo(() => getFieldRestrictions(allRestrictions, [getRequestName(TableElementFormField.columns)])
        ?.TableElementColumn?.Parameter, [allRestrictions]);
    const handleSubmit = useCallback((parameter) => {
        if (parameter) {
            onSubmit({
                columnId: column?.id,
                view: column?.view ?? TableElementColumnViewType.MOST_LIKELY,
                parameter: parameter,
                type: parameter.type,
            });
        }
        onClose();
    }, [column, onClose, onSubmit]);
    const selectedParameters = useMemo(() => [...columns]
        .filter(({ id }) => id !== column?.id)
        .map(({ parameter }) => parameter), [column?.id, columns]);
    return (React.createElement(ResultElementParameterSelect, { title: `${column?.id ? "Edit" : "New"} column`, allowedTypes: Object.values(ResultElementParameterType), selectedParameters: selectedParameters, customVariablesWithRecipeName: true, allowMultipleUnits: true, onSubmit: handleSubmit, restrictions: restrictions, onClose: onClose, initialValues: column?.parameter ?? undefined, classes: classes }));
};
export default ColumnDialog;
